export default __webpack_public_path__ + "static/media/pos-bill-list.d291ea1f.webp";